<template>
  <v-container fluid class="grey lighten-4 py-10">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <div class="pa-6 pa-md-10 ">
          <!-- Privacy Policy -->
          <v-card-title class="text-h4 font-weight-bold">
            Privacy Policy
          </v-card-title>
          <v-card-text class="body-1">
            <p class="mb-6">
              <strong>OH YES LLC.</strong> ("we", "us", or "our") operates the
              <strong>Oh Yes App</strong> (the "App"). This Privacy Policy
              describes how we collect, use, and disclose your information when
              you use the App. It also explains your privacy rights under U.S.
              laws, particularly in states such as California.
            </p>

            <!-- Section 1 -->
            <h3 class="text-h6 font-weight-bold mb-3">
              1. Information We Collect
            </h3>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <strong>Personal Information:</strong> Name, email address,
                  phone number, location, and other details when you sign up.
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <strong>Usage Data:</strong> IP address, device type,
                  operating system, browser type, and app interaction.
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <strong>Payment Information:</strong> Payment card information
                  may be processed by third-party providers.
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <!-- Section 2 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              2. How We Use Your Information
            </h3>
            <v-list dense>
              <v-list-item
                ><v-list-item-content
                  >To provide and maintain our App services</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >To improve user experience and
                  functionality</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >To communicate updates, offers, or
                  changes</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >To comply with legal obligations</v-list-item-content
                ></v-list-item
              >
            </v-list>

            <!-- Section 3 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              3. Third-Party Services and Service Partners
            </h3>
            <p>
              We may share your information with trusted service providers
              including:
            </p>
            <v-list dense>
              <v-list-item
                ><v-list-item-content
                  >Payment processors</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >Cloud storage providers</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >Analytics services</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >Service partners</v-list-item-content
                ></v-list-item
              >
            </v-list>
            <p class="mt-2">
              We do not sell your personal data and ensure third parties comply
              with data protection laws.
            </p>

            <!-- Section 4 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              4. Cookies and Tracking Technologies
            </h3>
            <v-list dense>
              <v-list-item
                ><v-list-item-content
                  >Cookies improve user experience</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >You may disable cookies in your browser
                  settings</v-list-item-content
                ></v-list-item
              >
            </v-list>

            <!-- Section 5 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">5. Your Rights</h3>
            <v-list dense>
              <v-list-item
                ><v-list-item-content
                  ><strong>Access & Deletion:</strong> Request access or
                  deletion of your data</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  ><strong>Opt-Out of Sale:</strong> California residents may
                  opt-out under CCPA</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  ><strong>Do Not Track:</strong> The App does not respond to
                  DNT signals</v-list-item-content
                ></v-list-item
              >
            </v-list>

            <!-- Section 6 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">6. Data Security</h3>
            <p>
              We use commercially reasonable safeguards, but no system is 100%
              secure.
            </p>

            <!-- Section 7 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              7. Children’s Privacy
            </h3>
            <p>
              Our App is not intended for children under 13. Any such data will
              be deleted immediately.
            </p>

            <!-- Section 8 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              8. Changes to This Privacy Policy
            </h3>
            <p>Updates will be posted on this page with the revised date.</p>

            <!-- Section 9 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">9. Contact Us</h3>
            <p>
              <strong>Gigvoc Technologies Pvt. Ltd.</strong><br />
              Email:
              <a href="mailto:info.usa@ohyesworld.com"
                >info.usa@ohyesworld.com</a
              ><br />
              Address: Oh Yes LLC, 11120 Glenbrook Ln, Indian Head Park, IL
              60525-6988, US
            </p>

            <v-divider class="my-10"></v-divider>

            <!-- Terms & Conditions -->
            <h2 class="text-h4 font-weight-bold mb-4">Terms & Conditions</h2>
            <p class="subtitle-2 mb-6">Last Updated: <strong>[Date]</strong></p>

            <!-- Section 1 -->
            <h3 class="text-h6 font-weight-bold mb-3">1. Use of the App</h3>
            <v-list dense>
              <v-list-item
                ><v-list-item-content
                  >You must be at least 13 years old</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >You are responsible for your account
                  security</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >You must provide accurate information</v-list-item-content
                ></v-list-item
              >
            </v-list>

            <!-- Section 2 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              2. Prohibited Conduct
            </h3>
            <v-list dense>
              <v-list-item
                ><v-list-item-content
                  >No illegal use</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >No system interference</v-list-item-content
                ></v-list-item
              >
              <v-list-item
                ><v-list-item-content
                  >No malware or hacking</v-list-item-content
                ></v-list-item
              >
            </v-list>

            <!-- Section 3 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              3. Intellectual Property
            </h3>
            <p>
              All content belongs to Gigvoc Technologies Pvt. Ltd. You may not
              copy, sell, or modify it.
            </p>

            <!-- Section 4 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">4. User Content</h3>
            <p>
              By submitting content, you grant us a worldwide license to use it.
              You are responsible for its legality.
            </p>

            <!-- Section 5 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              5. Third-Party Services
            </h3>
            <p>We are not responsible for external websites or services.</p>

            <!-- Section 6 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              6. Payments, Refunds & Cancellation
            </h3>
            <p>
              Refunds are processed within 10–15 working days after approval.
              Users may cancel bookings within one day.
            </p>

            <!-- Section 7 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">7. Termination</h3>
            <p>We may suspend or terminate access for violations.</p>

            <!-- Section 8 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">
              8. Disclaimer & Liability
            </h3>
            <p>
              The App is provided “as is.” We are not liable for indirect or
              consequential damages.
            </p>

            <!-- Section 9 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">9. Governing Law</h3>
            <p>
              Governed by the laws of the United States and your state of
              residence.
            </p>

            <!-- Section 10 -->
            <h3 class="text-h6 font-weight-bold mt-8 mb-3">10. Contact</h3>
            <p>
              <strong>OH YES LLC</strong><br />
              Email:
              <a href="mailto:info.usa@ohyesworld.com"
                >info.usa@ohyesworld.com</a
              ><br />
              Address: 11120 Glenbrook Ln, Indian Head Park, IL 60525-6988, US
            </p>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
  
  <script>
export default {
  name: "PrivacyPolicyUs",
};
</script>
  